/**
 * Moduł obsługi porównywarki produktów.
 * Zarządza stanem porównywarki (localStorage).
 */
app.service('comparisonState', function(localStorage, front) {
	const STORAGE_KEY = 'PRODUCT_COMPARISON_V2_COLLECTION';
	const MAX_PRODUCTS_PER_GROUP = 5;
	const MAX_GROUPS = 5;
	const MAX_VISIBLE_PRODUCT_TILES = 7;

	function getCollection() {
		const collection = localStorage.getItem(STORAGE_KEY);
		return collection ? JSON.parse(collection) : [];
	}

	function saveCollection(collection) {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(collection));
	}

	function getGroups() {
		const collection = getCollection();
		return collection.map(item => item.category);
	}

	function getGroupPresentationName(groupName) {
		const collection = getCollection();
		const group = collection.find(item => item.category === groupName);
		return group ? group.categoryPresentationName : null;
	}

	function getProductsByGroup(groupName) {
		const collection = getCollection();
		const group = collection.find(item => item.category === groupName);
		return (group && group.products) ? group.products.map(p => p.plu) : [];
	}

	function getAllProducts() {
		const collection = getCollection();
		const allProducts = [];
		collection.forEach(group => {
			if (group.products) {
				group.products.forEach(p => {
					allProducts.push({
						id: p.plu,
						groupName: group.category,
						thumbnail: p.thumbnail,
						name: p.name
					});
				});
			}
		});
		return allProducts;
	}

	function addProduct(plu, groupName, thumbnail, name) {
		const collection = getCollection();
		
		// Find or create group
		let group = collection.find(item => item.category === groupName);
		if (!group) {
			if (collection.length >= MAX_GROUPS) {
				return { success: false, reason: 'category_limit_reached', limit: MAX_GROUPS };
			}
			group = {
				category: groupName,
				products: [],
				categoryPresentationName: null	// Custom name for comparison group. It's set in KME.
			};
			collection.unshift(group);
		}

		// Return if product already exists
		const productExists = group.products.some(p => p.plu === plu);
		if (productExists) {
			return;
		}

		// Check limit
		if (group.products.length >= MAX_PRODUCTS_PER_GROUP) {
			return { success: false, reason: 'product_limit_reached', groupName: groupName };
		}

		// Add product
		group.products.unshift({
			plu: plu,
			thumbnail: `${front.getParam('staticDomain')}/foto/${thumbnail}`,
			name: name
		});
		
		saveCollection(collection);
		return { success: true, action: 'added' };
	}

	function removeProduct(plu, groupName) {
		const collection = getCollection();

		// Find group
		const group = collection.find(item => item.category === groupName);
		if (!group || !group.products) {
			return;
		}

		// Find and remove product
		const initialLength = group.products.length;
		group.products = group.products.filter(p => p.plu !== plu);

		// Return if product wasn't found
		if (group.products.length === initialLength) {
			return;
		}

		// Remove entire group if it becomes empty
		if (group.products.length === 0) {
			removeGroup(groupName);
			return { success: true, action: 'removed' };
		}
		
		saveCollection(collection);
		return { success: true, action: 'removed' };
	}

	function toggleProduct(product) {
		const { plu, category, thumbnail, name } = product;
		const products = getProductsByGroup(category);
		if (products.map(String).indexOf(plu.toString()) === -1) {
			return addProduct(plu, category, thumbnail, name);
		} else {
			return removeProduct(plu, category);
		}
	}

	function removeGroup(groupName) {
		const collection = getCollection();
		const updatedCollection = collection.filter(item => item.category !== groupName);
		saveCollection(updatedCollection);
	}

	function shouldSync(key) {
		return key === STORAGE_KEY;
	}

	function getMaxProductsPerGroup() {
		return parseInt(MAX_PRODUCTS_PER_GROUP);
	}

	function getMaxVisible() {
		return parseInt(MAX_VISIBLE_PRODUCT_TILES);
	}

	return {
		getProductsByGroup,
		getAllProducts,
		getGroups,
		getGroupPresentationName,
		toggleProduct,
		removeGroup,
		shouldSync,
		getMaxProductsPerGroup,
		getMaxVisible,
	};
});
